import { ft } from './utils';

export default {
  dialogDirection: 'rtl',
  dialogType: 'drawer',
  dialogModal: false,
  dialogEscape: false,
  highlightCurrentRow: true,
  border: true,
  stripe: true,
  index: true,
  indexLabel: ft('i18n_common_serial_number', '序号'),
  page: true,
  align: 'left',
  menuAlign: 'left',
  menuWidth: '140',
  menuType: 'text',
  addBtn: true,
  size: 'mini',
  refreshBtn: false,
  column: []
};
